export const PUBLIC_ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  REGISTER_CONFIRMATION: '/register/confirmation',
  REGISTER_WIZARD_CONFIRMATION: '/register-wizard/confirmation',
  PASSWORD_RESET: '/password-reset',
  PASSWORD_RESET_VERIFY: '/password-reset/verify',
  PARTNERSHIP: '/partnership',
  EULER_HERMES: '/euler-hermes',
  DISCREPANCY_REPORT: '/report/:userId-:name-:companyId',
  XERO: '/xero',
  HOME_PAGE: '/home-page',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  ABOUT: '/about',
  FAQ: '/faq',
  ASSESSMENT: '/assessment',
  CALCULATOR: '/calculator',
  ANGRY_AT_YOUR_CUSTOMERS: '/angry-at-your-customers',
  PRICING: '/pricing',
  CALENDAR_AUTH_CALLBACK: '/calendar/callback/:provider',
  ACCOUNT: '/account',
  NOT_FOUND: '/notfound',
};

export const FREE_SUBSCRIPTION_ROUTES = {
  ACCOUNT_ONBOARDING: '/account/onboarding',
  ACCOUNT_DASHBOARD: '/account/dashboard',
  ACCOUNT_MY_CUSTOMERS: '/account/my-customers',
  ACCOUNT_MY_CUSTOMERS_CREATE_MF: '/account/my-customers/create-mf',
  ACCOUNT_MY_CUSTOMERS_CREATE_MF_COMPANY: '/account/my-customers/create-mf/:paramCompanyID',
  ACCOUNT_MY_CUSTOMERS_EDIT_MF: '/account/my-customers/edit-mf/:masterFileId/:companyID',
  ACCOUNT_WRITE_REVIEW_EMPTY: '/account/write-review',
  ACCOUNT_COMPANIES: '/account/companies',
  ACCOUNT_COMPANY_DETAILS: '/account/company/:company_id',
  ACCOUNT_MY_COMPANIES: '/account/my-companies',
  ACCOUNT_MY_PROFILE: '/account/my-profile',
  ACCOUNT_MY_COMPANIES_EDIT: '/account/my-companies-edit/:claim_id/:company_id',
  ACCOUNT_MY_CUSTOMERS_METRICS: '/account/my-customers/metrics/:id/:page',
  ACCOUNT_MY_CUSTOMERS_WRITE_REVIEW: '/account/my-customers/write-review/:id',
  ACCOUNT_MY_CUSTOMERS_LOG_SERVICE: '/account/my-customers/log-service/:id/:page',
  ACCOUNT_MY_CUSTOMERS_ORDERS: '/account/my-customers/orders/:orderId',
  ACCOUNT_MY_CUSTOMERS_ORDERS_LIST: '/account/my-customers/orders-list/:masterFileId/:page',
  ACCOUNT_MY_CUSTOMERS_INVOICE_LIST: '/account/my-customers/invoice-list/:orderId/:page',
  ACCOUNT_SECURITY: '/account/security',
  ACCOUNT_SUBSCRIPTIONS: '/account/subscriptions',
  ACCOUNT_SUBSCRIPTION_PLAN: '/account/subscriptionplan',
  ACCOUNT_ACHIEVEMENTS: '/account/achievements',
  ACCOUNT_ACHIEVEMENTS_DAILY: '/account/achievements/daily',
  ACCOUNT_ACHIEVEMENTS_ONCE: '/account/achievements/once',
  ACCOUNT_ACHIEVEMENTS_HISTORY: '/account/achievements/history',
  ACCOUNT_COMPANY_INFO: '/account/company/info/:companyId',
  ACCOUNT_NOTIFICATIONS: '/account/notifications',
  ACCOUNT_NOTIFICATIONS_TEMPLATES: '/account/notifications/templates',
};

export const PAID_SUBSCRIPTION_ROUTES = {
  ACCOUNT_TOOL_KIT: '/account/tool-kit',
  ACCOUNT_TOOL_KIT_CREDIT_POLICY_WIZARD: '/account/tool-kit/credit-policy-wizard',
  ACCOUNT_TOOL_KIT_INTENSITY_MATRIX: '/account/tool-kit/intensity-matrix',
  ACCOUNT_TOOL_KIT_REPORTING_LINK: '/account/tool-kit/reporting-link',
  ACCOUNT_TOOL_KIT_DSO_REPORT: '/account/tool-kit/dso-report',
  ACCOUNT_KNOWLEDGE_BASE: '/account/knowledge-base',
  ACCOUNT_COMMUNITY_CUSTOMERS: '/account/community-customers',
  ACCOUNT_COMMUNITY_BANKS: '/account/community-banks',
  ACCOUNT_COMMUNITY_COLLEAGUES: '/account/community-colleagues',
  ACCOUNT_COMMUNITY_PROCESSES: '/account/community-processes',
  ACCOUNT_COMMUNITY_SOFTWARE_SERVICES: '/account/community-software-services',
  ACCOUNT_TALK_EXPERT: '/account/talk-expert',
  ACCOUNT_ACCREDITATION: '/account/accreditation',
};

export const toAccountRouteId = route => route.replace('/account/', '');
